// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__yDPIR","filesListContainer":"PosDisputesFiles_filesListContainer__3E0Oc","filesButton":"PosDisputesFiles_filesButton__2PaAY"};